import { EventRRule } from '@omecare/utils';
import { useTranslation } from 'react-i18next';
import DeleteAgendaSlotRecurrenceForm from '@/components/forms/delete-agenda-slot-recurrence/delete-agenda-slot-recurrence-form';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import {
  DeleteAgeandaSlotEventOccurence,
  DeleteAgendaSlotRecurrenceModalApi,
  selectDeleteAgendaSlotRecurrenceViewModel,
} from './delete-agenda-slot-recurrence-modal.viewmodel';

type DeleteAgendaSlotRecurrenceModalProps = {
  slot: {
    id: string;
    rrule: EventRRule;
    exdate: string[];
  };
  eventOccurrence: DeleteAgeandaSlotEventOccurence;
} & DeleteAgendaSlotRecurrenceModalApi;

export const DeleteAgendaSlotRecurrenceModal = ({
  slot,
  eventOccurrence,
  onDeleteOccurenceSuccess,
  onStopSeriesSuccess,
  onClose,
  onCancel,
}: DeleteAgendaSlotRecurrenceModalProps) => {
  const { t } = useTranslation();

  const viewModel = selectDeleteAgendaSlotRecurrenceViewModel({
    slotId: slot.id,
    eventOccurrence,
    api: {
      onDeleteOccurenceSuccess,
      onStopSeriesSuccess,
      onClose,
      onCancel,
    },
  });

  return (
    <Dialog open={viewModel.data.show}>
      <DialogContent
        className="sm:max-w-2xl"
        aria-describedby={undefined}
        showCloseButton={false}
        onInteractOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle>
            {t('delete-agenda-slot-recurrence-modal.title')}
          </DialogTitle>
        </DialogHeader>

        <DeleteAgendaSlotRecurrenceForm form={viewModel.data.form} />

        <DialogFooter>
          <Button
            variant="secondary"
            onClick={viewModel.api.cancel}
          >
            {t('btn.cancel')}
          </Button>

          <Button
            variant="destructive"
            onClick={viewModel.api.submit}
            loading={viewModel.data.deleting}
          >
            {t('btn.delete')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
